import React from "react"
import styles from "./styles.module.css"
import Home from "./Home"
import Category from "./Category"
import Article from "./Article"
import {getDir} from "./utils"

/**
 * ContentHub — module autonome.
 *
 * Usage : il suffit qu'un theme rende <ContentHub context={context}/> quand
 * page.type === "CONTENT_HUB". Tout le reste (header/footer/title) reste a la
 * charge du theme : ce composant s'occupe uniquement de la zone "contenu".
 *
 * La sous-route est resolue cote serveur dans services/RouterService.js et
 * exposee via context.contentHub :
 *   - { view: "home" }
 *   - { view: "category", categoryAid }
 *   - { view: "article", aid, article, recommendations, notFound }
 */

export default function ContentHub({context, className}) {
    const langValue = context?.langValue || "fr"
    const hub = context?.contentHub || {view: "home"}
    const dir = getDir(langValue)
    const rootClass = [styles.root, "contenthub-root", className].filter(Boolean).join(" ")

    return (
        <div className={rootClass} dir={dir} lang={langValue}>
            <div className={styles.container}>
                {hub.view === "article" && (
                    <Article
                        context={context}
                        article={hub.article}
                        recommendations={hub.recommendations || []}
                        breadcrumbAids={hub.breadcrumbAids || []}
                    />
                )}

                {hub.view === "category" && (
                    <Category
                        context={context}
                        langValue={langValue}
                        categoryAid={hub.categoryAid}
                    />
                )}

                {(!hub.view || hub.view === "home") && (
                    <Home context={context} langValue={langValue}/>
                )}
            </div>
        </div>
    )
}
